/**
 * Skeleton that mimics a league card: header block + 2-3 row blocks.
 * Reduces layout jump when scoreboard data loads.
 */

import React from 'react';
import { View } from 'react-native';
import { Skeleton } from '../../ui/Skeleton';
import { getLeagueSectionSkeletonStyles } from './LeagueSectionSkeleton.styles';
import { useTheme } from '../../../src/theme/useTheme';

const ROW_COUNT = 3;

export const LeagueSectionSkeleton: React.FC = () => {
  const theme = useTheme();
  const styles = React.useMemo(() => getLeagueSectionSkeletonStyles(theme), [theme]);

  return (
    <View testID="league-section-skeleton">
      {[1, 2].map((cardIndex) => (
        <View key={cardIndex} style={styles.card}>
          <View style={styles.header}>
            <Skeleton width={140} height={16} borderRadius={4} />
          </View>
          {Array.from({ length: ROW_COUNT }).map((_, rowIndex) => (
            <View key={rowIndex} style={styles.row}>
              <Skeleton width={36} height={12} borderRadius={4} />
              <Skeleton width="70%" height={12} borderRadius={4} />
              <Skeleton width={48} height={14} borderRadius={4} />
            </View>
          ))}
        </View>
      ))}
    </View>
  );
};
